import { render, staticRenderFns } from "./VueCrumbs.vue?vue&type=template&id=d786327c&"
import script from "./VueCrumbs.vue?vue&type=script&lang=js&"
export * from "./VueCrumbs.vue?vue&type=script&lang=js&"
import style0 from "./VueCrumbs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VueCrumbs.vue"
export default component.exports